import {indexOf} from 'lodash'
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: "values_by_keys"})
export class ValuesByKeysPipe implements PipeTransform {

    transform(keys: Array<number>, array: Array<any> = []): string {
        return array
            .filter(item => indexOf(keys, item.id) > -1)
            .map(item => item.name)
            .join(', ');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/pipes/values.by.keys.pipe.ts